export default __webpack_public_path__ + "locales/lo-LA/ChangeUserTypeDialog.json?hash=9c2d0f3259342e12ec62e4b2e155e0b6";